import Helpers from "@/services/helpers";
import { SET_PROGRESS } from "@/store/mutation-types";

export default {
  name: "core",
  install(ctx) {
    Helpers.mapStore(ctx, {
      progress: {
        get: "player/progress",
        set: `player/${SET_PROGRESS}`
      }
    });

    let tickTimer = null;
    let seek = 0;

    const getPrevIndex = function() {
      const currentIndex = this.currentIndex;
      const lastIndex = this.tracklistIds.length - 1;
      const prevIndex = currentIndex - 1 < 0 ? lastIndex : currentIndex - 1;
      const resultIndex = this.shuffle
        ? this.mod.shuffle.getIndex()
        : prevIndex;

      return resultIndex;
    }.bind(ctx);

    const getNextIndex = function(force) {
      const currentIndex = this.currentIndex;
      const lastIndex = this.tracklistIds.length - 1;
      const nextIndex = currentIndex + 1 > lastIndex ? 0 : currentIndex + 1;
      const resultIndex = this.shuffle
        ? this.mod.shuffle.getIndex()
        : nextIndex;

      if (this.shuffle) {
        return resultIndex;
      }

      switch (this.repeat) {
        case "track":
          return force ? resultIndex : currentIndex;
        case "playlist":
          return resultIndex;
        default:
          return currentIndex + 1 > lastIndex ? null : currentIndex + 1;
      }
    }.bind(ctx);

    const setProgress = function(customSeek) {
      clearTimeout(tickTimer);

      const trackSeek = customSeek || Number(this.currentTrack.seek()) || seek;
      const duration = this.currentTrack.duration;
      const jump = Math.abs(trackSeek - seek);

      if (jump < 3) {
        this.currentTrack.timecode += jump;
      }

      seek = trackSeek;

      requestAnimationFrame(() => {
        this.progress = (trackSeek / duration) * 100;
      });
    }.bind(ctx);

    const tick = function() {
      if (this.currentTrack) {
        setProgress();

        if (this.running) {
          tickTimer = setTimeout(() => {
            tick();
          }, 100);
        }
      }
    }.bind(ctx);

    const seekTo = function(value) {
      if (this.currentTrack) {
        this.currentTrack.seek(value + seek);
        tick();
      }
    }.bind(ctx);

    return {
      getPrevIndex,
      getNextIndex,
      setProgress,
      tick,
      seekTo,
      get seek() {
        return seek;
      },
      set seek(value) {
        seek = value;
      }
    };
  }
};
